export const formatLoginCode = (code: number | undefined) => {
  const codeStr = code?.toString()
  return `${codeStr?.slice(0, 4)} - ${codeStr?.slice(4)}`
}
